<template>
  <v-form ref="paymentDeliveryEditForm" v-model="valid" class="paymentDelivery-page">
    <v-row>
      <v-col cols="12">
        <h1>Оплата и доставка</h1>
      </v-col>

      <v-col cols="12" sm="5" md="4" xl="3">
        <v-tabs v-model="tab">
          <v-tab>Инфо</v-tab>
          <v-tab>Блоки</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="pt-6">
          <v-tab-item :eager="true">
            <v-img :src="previewImage(true, headerImage)" width="246" height="195" class="mb-8">
              <template v-slot:placeholder>
                <div class="image-placeholder"></div>
              </template>
            </v-img>
            <v-file-input label="Картинка"
                          prepend-icon=""
                          class="cursor-pointer"
                          outlined
                          placeholder="1768х1402"
                          append-icon="mdi-attachment"
                          v-model="headerImage">
            </v-file-input>
            <v-tabs v-model="tabLang">
              <v-tab>RU</v-tab>
              <v-tab>UA</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabLang">
              <v-tab-item :eager="true">
                <v-row>
                  <v-col>
                    <v-text-field
                        v-model="paymentDelivery.title"
                        label="Заголовок"
                        outlined
                    ></v-text-field>
                    <v-textarea
                        v-model="paymentDelivery.description"
                        label="Описание"
                        outlined
                    ></v-textarea>
                    <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i"
                            v-model="paymentDelivery.url_block" :init="{}" :toolbar="toolbar" :plugins="plugins"/>
                    <v-text-field
                        v-model="paymentDelivery.button_text"
                        label="Текст кнопки"
                        outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :eager="true">
                <v-row>
                  <v-col>
                    <v-text-field
                        v-model="paymentDelivery.title_ua"
                        label="Заголовок"
                        outlined
                    ></v-text-field>
                    <v-textarea
                        v-model="paymentDelivery.description_ua"
                        label="Описание"
                        outlined
                    ></v-textarea>
                    <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i"
                            v-model="paymentDelivery.url_block_ua" :init="{}" :toolbar="toolbar" :plugins="plugins"/>
                    <v-text-field
                        v-model="paymentDelivery.button_text_ua"
                        label="Текст кнопки"
                        outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
            <v-text-field
                v-model="paymentDelivery.button_url"
                label="Ссылка"
                outlined
            ></v-text-field>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col cols="12" sm="12" md="12" xl="12">
                <div v-if="paymentDelivery.blocks" v-for="(block, index) in paymentDelivery.blocks" >
                  <div class="text"><span>Блок {{ index + 1}}</span><div class="remove" @click="submitDialog = true; submitItem = block"><v-icon>mdi-close</v-icon></div></div>
                  <div class="block" :class="{reverse: block.is_reverse}">
                    <div class="left">
                      <v-img :src="block.image_url" width="246" height="195" class="mb-8">
                        <template v-slot:placeholder>
                          <div class="image-placeholder"></div>
                        </template>
                      </v-img>
                      <v-file-input label="Картинка"
                                    prepend-icon=""
                                    class="cursor-pointer"
                                    outlined
                                    @change="appendImage(block)"
                                    placeholder="1902х1508.jpg"
                                    append-icon="mdi-attachment"
                                    hide-details
                                    v-model="block.image_file">
                      </v-file-input>
                    </div>
                    <div class="reverse" @click="block.is_reverse = !block.is_reverse"><v-icon large>mdi-swap-horizontal</v-icon></div>
                    <div class="right">
                      <v-tabs v-model="block.tab" class="pb-2">
                        <v-tab>RU</v-tab>
                        <v-tab>UA</v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="block.tab">
                        <v-tab-item :eager="true">
                          <v-text-field
                              v-model="block.title"
                              label="Заголовок"
                              outlined
                          ></v-text-field>
                          <v-textarea
                              v-model="block.description"
                              label="Описание"
                              outlined
                              hide-details
                          ></v-textarea>

                        </v-tab-item>
                        <v-tab-item :eager="true">
                          <v-text-field
                              v-model="block.title_ua"
                              label="Заголовок"
                              outlined
                          ></v-text-field>
                          <v-textarea
                              v-model="block.description_ua"
                              label="Описание"
                              outlined
                              hide-details
                          ></v-textarea>
                        </v-tab-item>
                      </v-tabs-items>
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <v-btn outlined @click="addBlock">Добавить блок</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>

        <v-btn @click="update">Сохранить</v-btn>
      </v-col>
      <v-dialog
          v-model="submitDialog"
          max-width="444"
      >
        <v-card>
          <v-card-title >
            Подтвердить действие
          </v-card-title>

          <v-card-actions>


            <v-btn
                v-if="submitItem == null"
                @click="submitDelete(submitItem); submitDialog = false">
              Да
            </v-btn>
            <v-btn
                v-else
                @click="submitDelete(submitItem); submitDialog = false">
              Да
            </v-btn>
            <v-btn
                outlined
                @click="submitDialog = false"
            >
              Нет
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          right
          top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
// @ is an alias to /src
import PageService from './../../api/PageService'
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'PaymentDelivery',
  props: {},
  components: {Editor},
  data: () => ({
    plugins: 'advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount',
    toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code ',
    snackbar: false,
    timeout: 2000,
    snackbarText: '',
    snackbarColor: '',
    submitDialog: false,
    submitItem: null,
    block: {
      tab: 0,
      image: '',
      image_url: '',
      is_reverse: false,
      title: '',
      title_ua: '',
      description: '',
      description_ua: '',
      image_file: null,
    },
    rules: {
      required: value => !!value || 'Нужно заполнить',
      requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
    },
    valid: true,
    tab: '',
    tabLang: '',
    headerImage: null,
    paymentDelivery: {
      image: null,
      image_url: null,
      blocks: [],
    },
    loading: true,
    loadingButton: false,
  }),
  mounted() {
    PageService.getPaymentDelivery()
        .then(response => {
          let data = response.data
          if(data.blocks === undefined){
            data.blocks = []
          }


          data.blocks.forEach(function (item) {
            if(item.image_url !== ''){
              item.image_file = {}
              item.image_file.url = item.image_url;
              item.image_file.name = item.image
            }
          })
          console.log(data)
          this.paymentDelivery = data;

          if (this.paymentDelivery.image) {
            this.headerImage = {}
            this.headerImage.url = this.paymentDelivery.image_url;
            this.headerImage.name = this.paymentDelivery.image
          }
          this.loading = false
        });
  },
  methods: {
    submitDelete(block){
      this.paymentDelivery.blocks.splice(this.paymentDelivery.blocks.indexOf(block) , 1)
    },
    addBlock(){
      if(this.paymentDelivery.blocks === undefined || !this.paymentDelivery.blocks){
        this.paymentDelivery.blocks = []
      }

      this.paymentDelivery.blocks.push(Object.assign({}, this.block))
    },
    appendImage(block){
      block.image_url = URL.createObjectURL(block.image_file)
    },
    previewImageBlock(imageFile) {
      if (imageFile) {
        return URL.createObjectURL(imageFile)
      }
    },
    validate() {


    },
    previewImage(isHeader, image) {
      if (isHeader) {
        if (this.headerImage && this.headerImage.url) {
          return this.headerImage.url
        }
      } else {
        if (this.footerImage && this.footerImage.url) {
          return this.footerImage.url
        }
      }

      if (image) {
        return URL.createObjectURL(image)
      }
    },
    update() {

      this.loadingButton = true;
      let formData = this.getData();

      PageService.updatePaymentDelivery(formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Страница успешно обновлена';
        this.snackbarColor = 'success';
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при обновлении страницы';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },
    getData() {
      let formData = new FormData();

      formData.append('title', this.paymentDelivery.title);
      formData.append('title_ua', this.paymentDelivery.title_ua);
      formData.append('description', this.paymentDelivery.description);
      formData.append('description_ua', this.paymentDelivery.description_ua);
      formData.append('button_text', this.paymentDelivery.button_text);
      formData.append('button_text_ua', this.paymentDelivery.button_text_ua);
      formData.append('button_url', this.paymentDelivery.button_url);
      formData.append('url_block', this.paymentDelivery.url_block);
      formData.append('url_block_ua', this.paymentDelivery.url_block_ua);

      this.paymentDelivery.blocks.forEach(function (item, index) {
        formData.append(`blocks[${index}][title]`, item.title);
        formData.append(`blocks[${index}][title_ua]`, item.title_ua);
        formData.append(`blocks[${index}][description]`, item.description);
        formData.append(`blocks[${index}][description_ua]`, item.description_ua);
        formData.append(`blocks[${index}][image]`, item.image);
        formData.append(`blocks[${index}][image_url]`, item.image_url);
        formData.append(`blocks[${index}][is_reverse]`, item.is_reverse);

        if(item.image_file && !item.image_file.url) {
          formData.append(`blocks[${index}][image_file]`, item.image_file);
        }
      })

      if (this.headerImage && !this.headerImage.url) {
        formData.append('headerImage', this.headerImage);
      }

      return formData;
    }
  },
}
</script>

<style lang="scss">
.paymentDelivery-page {
  .v-input__append-inner {
    margin-top: 13px !important;
  }
}
</style>

<style scoped lang="scss">
.block{
  display: grid;
  grid-template-columns: 31% 6% 48%;
  grid-column-gap: 7.5%;
  border-bottom: 1px solid #E0E8F0;
  padding-bottom: 32px;
  margin-bottom: 32px;



  .reverse{
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  &.reverse{
    grid-template-columns: 48% 6% 31%;
    .left{
      order: 3;
    }
    .right{
      order: 1;
    }
    .reverse{
      order: 2;
    }
  }
}
.image-placeholder {
  width: 100%;
  height: 100%;
  background-color: #F3F7FC;
  border-radius: 4px;
}
.paymentDelivery-images .v-image {
  max-height: 374px;
}

.mobile {
  width: 300px;
  height: 300px;
  margin-bottom: 24px;
}

.paymentDelivery {
  position: relative;

  &:before {
    content: "";
    padding-top: 100%;
    display: block;
  }

  .content {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #F8FBFF;
    border-right-style: 3px;

    .img {
      height: 3.541vw;
      margin-top: .83vw;
    }

    .name {
      margin-top: .72vw;
      text-align: center;
      color: #8C959D;
    }
  }
}
</style>
